import { Layout } from 'antd';
import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import HeaderLinks from '../../components/Header/HeaderLinks';
import Sidebar from '../../components/Sidebar/Sidebar';
import MyUtil from '../../functions/MyUtil';
import PartRoutes from '../../routes/routerPartners';
import routes from '../../routes/routers';
import { style } from '../../variables/Variables';

class Home extends Component {
  constructor(props) {
    super(props);

    const userInfo = reactLocalStorage.getObject('user.info');
    this.isLogin = !!(
      userInfo &&
      (userInfo.user_role_id === 2 || userInfo.user_role_id === 3)
    );
    this.isPartner = userInfo ? userInfo.user_role_id === 3 : false;
  }

  render() {
    const routers = this.isPartner ? PartRoutes : routes;
    const { pathname } = this.props.location;

    const bookCode = pathname.split('/').pop();
    const { hash } = MyUtil.getQueryParam();

    if (!this.isLogin && !pathname.includes('widget')) {
      return <Redirect push to="/login" />;
    }

    if (!this.isLogin && pathname.includes('widget')) {
      return (
        <Redirect
          push
          to={{
            pathname: '/login',
            search: `?url=${`/widget/partner/booking/${bookCode}?hash=${hash}`}`,
          }}
        />
      );
    }
    return (
      <Layout className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        {!pathname.includes('widget') && <Sidebar />}
        <Layout className="main-panel">
          <HeaderLinks />
          <Layout.Content className="main-content">
            <Switch>{routers.map(renderRoute)}</Switch>
          </Layout.Content>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(Home);

function renderRoute(route) {
  if (route.children) {
    return route.children.map(renderRoute);
  }

  return (
    <Route
      path={route.path}
      component={route.component}
      key={route.path ?? route.name}
    />
  );
}
